import ajax from "@/lib/ajax";

/**
 * 读取质控提醒信息
 * @param payload 查询条件
 */
export async function GetQualityControlList(payload: any) {
    let res = await ajax.get(`/api/services/app/PDQualityControlReminder/GetQualityControlList`,{params:payload} );
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdQualityControlManage/pdQualityControlReminder/index.ts